export default "__VITE_ASSET__DA5NgB4k__"